import { SolType } from '@sol/components';
import { AttachmentDto } from '../tools/asm-attachment-tools';
import { Annotation } from './annotation';
import { OwaspClassification } from './owasp-classification';

export class AsmCollaborationType {
  public static readonly annotation = SolType.ofObject<Annotation>('asm.annotation', {
    id: SolType.string,
    text: SolType.string,
    user: SolType.string,
    date: SolType.date,
  });
  public static readonly attachment = SolType.ofObject<AttachmentDto>('attachment', {
    type: SolType.string,
    url: SolType.string,
    name: SolType.string,
  });
  public static readonly owaspClassification = SolType.ofObject<OwaspClassification>('asm.owaspClassification', {
    edition: SolType.string,
    classification: SolType.number,
    name: SolType.string,
  });
  /** One OWASP Top 10 classification code, spelled as the findings table spells it, e.g. `A01:2025`. */
  public static readonly owaspCode = SolType.ofPrimitive<string>(
    'owaspCode',
    () => '',
    v => v ?? '',
    s => s,
    SolType.string,
  );
  /** One OWASP Top 10 edition key, e.g. `owasp_2021`, as `ObservationClassification.owasp_type` (asm-backend) stores it. */
  public static readonly owaspVersion = SolType.ofPrimitive<string>(
    'owaspVersion',
    () => '',
    v => v ?? '',
    s => s,
    SolType.string,
  );
}
